export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.config.errorHandler = (err, instance, info) => {
    console.error('Ошибка Vue:', err.stack); // Вывод полного стектрейса
    console.log('Информация:', info); // Дополнительный контекст
  };
});